/** Auto-generated by import-constants plugin. Do not edit manually */

export const optionalImportEntrypoints: string[] = [
  "langchain_classic/agents/load",
  "langchain_classic/agents/toolkits/sql",
  "langchain_classic/tools/sql",
  "langchain_classic/tools/webbrowser",
  "langchain_classic/chains/load",
  "langchain_classic/chains/query_constructor",
  "langchain_classic/chains/query_constructor/ir",
  "langchain_classic/chains/sql_db",
  "langchain_classic/chains/graph_qa/cypher",
  "langchain_classic/chat_models/universal",
  "langchain_classic/document_loaders/fs/buffer",
  "langchain_classic/document_loaders/fs/directory",
  "langchain_classic/document_loaders/fs/json",
  "langchain_classic/document_loaders/fs/multi_file",
  "langchain_classic/document_loaders/fs/text",
  "langchain_classic/sql_db",
  "langchain_classic/output_parsers/expression",
  "langchain_classic/retrievers/self_query",
  "langchain_classic/retrievers/self_query/functional",
  "langchain_classic/cache/file_system",
  "langchain_classic/stores/file/node",
  "langchain_classic/storage/file_system",
  "langchain_classic/hub",
  "langchain_classic/hub/node",
];
